import React from 'react';
import { useStore } from '../../store/useStore';
import { Browse } from './Browse';
import { ProductDetail } from './ProductDetail';
import { ReserveConfirm } from './ReserveConfirm';
import { PostPickup } from './PostPickup';
import { ClaimResult } from './ClaimResult';
import { Home, MapPin, Diamond, Tag, MoreHorizontal } from 'lucide-react';
export function ShopperApp() {
  const {
    shopperCurrentView
  } = useStore();
  return <div className="h-full flex flex-col bg-white relative" data-id="element-494">
      <div className="flex-1 overflow-y-auto pb-[72px]" data-id="element-495">
        {shopperCurrentView === 'Browse' && <Browse data-id="element-496" />}
        {shopperCurrentView === 'Detail' && <ProductDetail data-id="element-497" />}
        {shopperCurrentView === 'ReserveConfirm' && <ReserveConfirm data-id="element-498" />}
        {shopperCurrentView === 'PostPickup' && <PostPickup data-id="element-499" />}
        {shopperCurrentView === 'ClaimResult' && <ClaimResult data-id="element-500" />}
      </div>

      {/* Bottom Navigation */}
      <div className="absolute bottom-0 left-0 right-0 bg-white border-t border-[rgba(37,41,53,0.12)] flex justify-between items-center px-6 py-3 z-50" data-id="element-501">
        <button className="flex flex-col items-center gap-1 text-[#00CDBE]" data-id="element-502">
          <Home className="w-6 h-6" data-id="element-503" />
          <span className="text-[10px] font-medium" data-id="element-504">Home</span>
        </button>
        <button className="flex flex-col items-center gap-1 text-[#252935]" data-id="element-505">
          <MapPin className="w-6 h-6" data-id="element-506" />
          <span className="text-[10px] font-medium" data-id="element-507">Maps</span>
        </button>
        <button className="flex flex-col items-center gap-1 text-[#252935]" data-id="element-508">
          <Diamond className="w-6 h-6" data-id="element-509" />
          <span className="text-[10px] font-medium" data-id="element-510">Brands</span>
        </button>
        <button className="flex flex-col items-center gap-1 text-[#252935]" data-id="element-511">
          <Tag className="w-6 h-6" data-id="element-512" />
          <span className="text-[10px] font-medium" data-id="element-513">Deals</span>
        </button>
        <button className="flex flex-col items-center gap-1 text-[#252935]" data-id="element-514">
          <MoreHorizontal className="w-6 h-6" data-id="element-515" />
          <span className="text-[10px] font-medium" data-id="element-516">More</span>
        </button>
      </div>
    </div>;
}